import { createAppStore } from '@app/core/stores';

type NotificationsTourDemoState = {
  /** True while the notifications tour should show empty-only demo feed rows. */
  active: boolean;
  setActive: (active: boolean) => void;
};

/**
 * Ephemeral flag shared between the notifications tour and the MUI feed.
 * Not persisted — cleared when the tour ends.
 */
export const useNotificationsTourDemoStore = createAppStore<NotificationsTourDemoState>(
  'NotificationsTourDemoStore',
)((set) => ({
  active: false,
  setActive: (active) => set({ active }),
}));
